import { render } from "./CreateInternationalCalculation.vue?vue&type=template&id=1bc8551f&scoped=true&ts=true"
import script from "./CreateInternationalCalculation.vue?vue&type=script&lang=ts"
export * from "./CreateInternationalCalculation.vue?vue&type=script&lang=ts"

import "./CreateInternationalCalculation.vue?vue&type=style&index=0&id=1bc8551f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc8551f"]])

export default __exports__